// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__WrA7E","popup":"Dropdown_popup__fqMXE"};